/**
 * xStreamId处理方法
 */
import { setLocalStorage, getLocalStorage, removeLocalStorage } from './index.js'
import _ from 'lodash'

const T_NAME = 'x-stream-id-jssdk'

// 设置从header中获取token
export function getTokenFromHeaders(headers) {
  let xStreamId
  if (headers[0]) {
    _.forEach(_.values(headers), header => {
      for (const key in header) {
        if (key === 'x-stream-id' || key === 'X-Stream-Id') {
          xStreamId = header[key]
        }
      }
    })
  } else {
    xStreamId = headers['x-stream-id']
    if (!xStreamId) xStreamId = headers['X-Stream-Id']
  }

  return xStreamId instanceof Array ? xStreamId[0] : xStreamId
}

// 设置x-stream-id
export function setToken(token) {
  // 过期时间为10h
  setLocalStorage(T_NAME, token, 36000000)
}

// 读取x-stream-id
export function getToken() {
  const xStreamId = getLocalStorage(T_NAME) || ''
  return xStreamId
}

// 清除token
export function clearToken() {
  removeLocalStorage(T_NAME)
}

// 从传参中获取token
export function getSearchToken() {
  let xStreamId = ''
  const matched = window.location.href.match(/x_stream_id=(.*)/)
  if (matched) {
    // 先把地址栏中的转义处理一下, 然后将可能存在的/直接删除,
    matched[1] = matched[1]
      .replace(/-\._/g, '#')
      .replace(/\._~/g, '&')
      .replace(/!/g, '?')
      .replace(/\//g, '')

    // 先以hash分割
    if (matched[1].indexOf('#') > -1) {
      matched[1] = matched[1].split('#')[0]
    }

    const index1 = matched[1].indexOf('&')
    const index2 = matched[1].indexOf('?')
    let str = ''

    // 看看最近的一个字符是&还是？
    if (index1 < index2) {
      str = '&'
    } else {
      str = '?'
      if (index2 < 0) {
        str = '&'
      }
    }

    // 判断最近的字符是否存在存在，然后取xStreamId
    if (matched[1].indexOf(str) > -1) {
      xStreamId = matched[1].split(str)[0]
    } else {
      xStreamId = matched[1]
    }
  }

  if (!xStreamId) return
  // 缓存x_stream_id，11小时
  setLocalStorage(T_NAME, xStreamId, new Date().getTime() + 39600000)
}
